
export const currencies = [
  { code: "JPY", symbol: "¥" },
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "GBP", symbol: "£" },
  { code: "CNY", symbol: "¥" },
  { code: "CHF", symbol: "Fr" },
  { code: "CAD", symbol: "C$" },
  { code: "AUD", symbol: "A$" },
  { code: "KRW", symbol: "₩" },
  { code: "HKD", symbol: "HK$" },
  { code: "SGD", symbol: "S$" },
  { code: "SEK", symbol: "kr" },
  { code: "NOK", symbol: "kr" },
  { code: "INR", symbol: "₹" },
  { code: "BRL", symbol: "R$" },
  { code: "RUB", symbol: "₽" },
  { code: "MXN", symbol: "Mex$" },
  { code: "NZD", symbol: "NZ$" },
  { code: "ZAR", symbol: "R" },
  { code: "TRY", symbol: "₺" },
  { code: "THB", symbol: "฿" }
];
